import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginator } from '@/shared/models/cruds.models'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { configurationAccountingBillableUnitsService } from '@/modules/configurationModule/detail/accounting/billable/units/services/configuration-accounting-billable-unit/configuration-accounting-billable-unit.service'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'

export const columnsDefAccountingUnitGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.unit'),
            field: 'name',
            minWidth: 150,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.symbol'),
            field: 'symbol',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.default'),
            field: 'isDefault',
            minWidth: 80,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true,
            sortable: true
        }
    ]

export enum ConfigurationLocalAccountingUnitGridSidepanelComboElements {
    RATES = 1
}

export interface ConfigurationAccountingUnitGridState extends CrudModelPaginator<AccountingUnitResponse> {
    service: typeof configurationAccountingBillableUnitsService
}
export const initialConfigurationAccountingUnitGridState =
    (): ConfigurationAccountingUnitGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.accounting.billable.units',
        columnsDef: columnsDefAccountingUnitGrid(),
        datasource: new PaginatorDatasource(configurationAccountingBillableUnitsService),
        service: configurationAccountingBillableUnitsService
    })
